<!--
  画面名： -
  画面概要：食材登録フォームのコンポーネント
  備考：FoodRegistrationForm.vueもほとんど内容なので、このファイルを修正時は確認して下さい。
-->

<template lang="html">
  <v-form
    v-model="valid"
    ref="foodForm"
    lazy-validation
  >
    <!-- セレクトボックスから選択された項目を表示 -->
    <div class="registerArea">
      <!-- 名称 -->
      <v-layout>
        <v-flex class="sm6">
          <v-text-field
          v-model="menu"
          :placeholder="$language.LabelName"
          :rules="[menuRules]"
          :disabled="isTemplate"
          />
        </v-flex>
        <!-- 種別 -->
        <v-flex class="sm3">
          <v-select
            v-model="type"
            :placeholder="$language.LabelType"
            :items="types"
            item-value="id"
            item-text="text"
            class="ml-2"
            :rules="[typeRules]"
            :disabled="isTemplate"
          />
        </v-flex>
        <!-- カテゴリー -->
        <v-flex class="sm3" @click="alertCategory()">
          <v-select
            :disabled="type < 0 || isTemplate"
            v-model="category"
            :placeholder="$language.LabelCategory"
            :items="categoryLists[type]"
            item-value="id"
            item-text="text"
            class="ml-2 categorySelect"
            :rules="[categoryRules]"
          />
        </v-flex>
      </v-layout>
      <!-- 食材グループ設定用リストボックス -->
      <v-flex class="xs12 sm7">
        <v-select
          placeholder="グループ"
          v-model="foodGroup"
          :items="groups"
          item-value="id"
          item-text="text"
          :rules="[groupRules]"
        />
      </v-flex>
      <!-- 工程と管理方法を表示するエリア -->
      <section style="margin-top: 10px !important;" class="process mt-4" v-if="type!=2">
        <h3 style="padding-bottom: 4px;">{{$language.LabelProcess}}</h3>
        <table>
          <tbody>
            <tr>
              <td
                v-for="(process, index) in processes"
                :key="index"
              >
                <v-checkbox v-model="processChecks" :value="process.id" :label="process.name"></v-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <!-- アレルゲンを表示するエリア -->
      <Allergen
        class="mt-4"
        :allergenchecked="allergenChecks"
        @send="openParentDialog"
        ref="refAllergen"
      />
    </div>
    <!-- 確認ダイアログ -->
    <ConfirmDialog :msg="$language.MsgSelectedType" :isYes="true" ref="confirmDialog"></ConfirmDialog>

  </v-form>
</template>

<script>
// アレルゲン
import Allergen from '@/components/parts/common/Allergen'
// 確認用モーダル
import ConfirmDialog from '@/components/parts/common/ConfirmDialog'
// 食材用定義ファイル
import DefFood from '@/config/common/foodData.json'

export default {
  name: 'FoodRegistrationFormModal',
  // 親ページのデータを取得
  props: {
    // 計画策定からの判定
    isPlan: { type: Boolean, default: false }
  },
  // 子（外部）コンポーネント設定
  components: {
    // アレルゲン
    Allergen,
    // 確認ダイアログ
    ConfirmDialog
  },
  // コンポーネント内の変数を定義
  data () {
    return {
      // 名称
      menu: '',
      // 初期表示する食材グループ
      foodGroup: '',
      // 食材グループ一覧
      groups: [],
      // 種別
      type: -1,
      // 定義ファイルを格納する
      defFood: [],
      // 種別一覧
      types: [],
      // チェックされたアレルゲンを文字列で格納
      allergenChecks: '',
      // カテゴリ
      category: '',
      // カテゴリリスト
      categoryLists: [],
      // プロセス
      processes: [],
      // チェックされた作業工程を格納する配列
      processChecks: [],
      // バリデーションのチェックフラグ
      valid: true,
      // 雛形の食材か判定する
      isTemplate: false,
      // 事業社DBに登録する雛形食材IDの初期値
      baseId: -1,
      // 料理に含まれる食材
      cookingMaterial: ''

    }
  },
  // Vueインスタンスを監視
  watch: {
    // 食材グループに対応する工程を設定するグループが変わるたびに工程のチェックを変更する
    foodGroup () {
      this.setProcessByfoodGroup()
    }
  },
  // 画面表示時に実行する関数を設定
  created () {
    // 食材の定義ファイルを設定
    this.defFood = DefFood.Food
    // 食材種別リストを取得する
    this.getTypeList()
  },
  // 関数群
  methods: {
    // 種別を選択する前にカテゴリをクリックした際はアラートを表示する
    alertCategory () {
      if (this.type < 0) {
        // 種別を選択して下さい、のアラートを表示する
        this.openConfirmDialog()
      }
    },
    // 確認用ダイアログを表示
    openConfirmDialog () {
      this.$refs.confirmDialog.openDialog()
    },
    // 食材グループに対応する工程を設定する
    setProcessByfoodGroup () {
      let f = this.defFood
      if (this.foodGroup === f.Normal) {
        // グループ0：加熱殺菌や冷却せず、常温のまま提供するもの
        this.processChecks = [f.Reception, f.Storage, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.Unheated) {
        // グループ1：加熱殺菌せず、冷たいまま提供するもの
        this.processChecks = [f.Reception, f.Storage, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.HeatRefrigerated) {
        // グループ2：加熱殺菌し、熱いまま提供するもの
        this.processChecks = [f.Reception, f.Storage, f.Heating, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.AllHeating) {
        // グループ2：加熱殺菌後に高温保管した後、熱いまま提供するもの
        this.processChecks = [f.Reception, f.Storage, f.Heating, f.Storage2, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.CoolAfterHeat) {
        // グループ3：加熱殺菌後冷却して、冷たいまま提供するもの
        this.processChecks = [f.Reception, f.Storage, f.Heating, f.Cooling, f.Dishing, f.Offer]
      } else if (this.foodGroup === f.ReHeating) {
        // グループ3：加熱殺菌後冷却して、再加熱し、熱いまま提供するもの
        this.processChecks = [f.Reception, f.Storage, f.Heating, f.Cooling, f.Reheating, f.Dishing, f.Offer]
      } else {
        // グループなし
        this.processChecks = [f.Reception, f.Storage]
      }
    },
    /**
     * DB操作
     */
    // 食材の種別リストを取得する
    getTypeList () {
      let self = this
      // 食材種別リスト取得のコールバック処理
      function callbackGetTypeList (response) {
        // データベースから取得した食材の種別リストを格納
        // 種別から「料理」を削除
        response.pop()
        self.types = response
        self.$forceUpdate()
        // 食材カテゴリのjsonデータを取得する
        self.getCategoryJson()
      }
      let data = {}
      data.callback = callbackGetTypeList
      this.$store.dispatch('types/actionSelectTypes', data)
    },
    // カテゴリのjsonデータを取得する
    getCategoryJson () {
      let self = this
      // カテゴリー一覧を取得した後のコールバック処理
      function callbackGetCategoryJson (response) {
        // データベースから取得したアレルゲン一覧を格納
        self.categoryLists = response
        self.$forceUpdate()
        self.getFoodGroup()
      }
      let data = {}
      data.callback = callbackGetCategoryJson
      this.$store.dispatch('foodCategory/actionSelectFoodCategory', data)
    },
    // DBから食材グループ取得
    getFoodGroup () {
      let self = this
      // 食材グループを取得した際のコールバック処理
      function callbackGetFoodGroup (response) {
        // データベースから取得した食材グループを格納
        self.groups = response
        self.$forceUpdate()
        // 食材グループをDBから取得
        self.getProcess()
      }
      let data = {}
      data.callback = callbackGetFoodGroup
      this.$store.dispatch('foodGroups/actionSelectFoodGroups', data)
    },
    // DBから工程を取得
    getProcess () {
      let self = this
      // 作業工程を取得した際のコールバック処理
      function callbackGetProcess (response) {
        // データベースから取得したアレルゲン一覧を格納
        self.processes = response
        self.$forceUpdate()
        self.$refs.refAllergen.makeAllergenFrame()
      }
      let data = {}
      data.callback = callbackGetProcess
      this.$store.dispatch('processes/actionSelectProcesses', data)
    },
    // 親コンポーネントFoodModalをダイアログ表示させる
    openParentDialog () {
      this.$emit('showDialog')
    },

    /**
     * バリデーションルールを設定
     */
    // 名称バリデーション設定
    menuRules () {
      // メニュー名バリデーション
      if (this.menu) {
        return true
      } else {
        return this.$language.MsgNecessary
      }
    },
    // 種別のバリデーション設定
    typeRules () {
      if (this.type >= 0) {
        return true
      } else {
        return this.$language.MsgNecessary
      }
    },
    // カテゴリバリデーション設定
    categoryRules () {
      if (this.type === this.defFood.RawMaterial) {
        if (this.category >= 100 && this.category <= 199) {
          return true
        }
      } else if (this.type === this.defFood.Preparation) {
        if (this.category >= 200 && this.category <= 299) {
          return true
        }
      }
      // 「必須項目です」のメッセージを返す
      return this.$language.MsgNecessary
    },
    // 食材グループのバリデーション
    groupRules () {
      if (this.foodGroup >= 0) {
        return true
      } else {
        return this.$language.MsgNecessary
      }
    },
    // バリデーション
    validate () {
      if (this.$refs.foodForm.validate()) {
        this.$emit(
          'confirm',
          {
            food: this.menu,
            type: this.type,
            category: this.category,
            group: this.foodGroup,
            allergen: this.$refs.refAllergen.allergenChecks.join(','),
            process: this.processChecks.join(','),
            cookingMaterial: '',
            baseId: this.baseId
          }
        )
      }
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/common/foodData.scss';
</style>
